import {
  comboBox,
  createFormRow,
  FluidLocale,
  FluidLookup,
  inputField,
  required,
} from '@lmig/fluid-core';

import { mergeTranslations } from '../../address-form.config.utils';
import {
  FluidAddressFormConfig,
  FluidAddressFormConfiguration,
} from '../../fluid-address-form-config.class';
import { usAddressTranslations } from './us-address.translations';

export const usAddressConfig = (config: FluidAddressFormConfiguration) => {
  const addressForm: FluidAddressFormConfig = new FluidAddressFormConfig(
    FluidLocale.UNITED_STATES,
    mergeTranslations(config, usAddressTranslations)
  );

  /**
   * Set-up the row options for the form grid.
   */
  addressForm.setRowOptions([
    createFormRow(1, [12]),
    createFormRow(2, [12]),
    createFormRow(3, [12]),
    createFormRow(4, [12]),
    createFormRow(5, [12]),
    createFormRow(6, [6, 6]),
  ]);

  addressForm.setElements([
    comboBox({
      ...addressForm.field('country', 1, 1),
      options: FluidLookup.country,
      validation: [
        required({
          message: addressForm.translate('country', 'validation.required'),
        }),
      ],
    }),
    inputField({
      ...addressForm.title('addressTitle', 2, 1),
    }),
    inputField({
      ...addressForm.field('addressLineOne', 3, 1),
    }),
    inputField({
      ...addressForm.field('addressLineTwo', 4, 1),
    }),
    inputField({
      ...addressForm.field('townOrCity', 5, 1),
    }),
    comboBox({
      ...addressForm.field('countyOrProvince', 6, 2),
      options: FluidLookup.regional.us,
    }),
    inputField({
      ...addressForm.field('postOrZipCode', 6, 1),
      validation: [
        required({
          message: addressForm.translate(
            'postOrZipCode',
            'validation.required'
          ),
        }),
      ],
    }),
  ]);

  return addressForm;
};
